import { ImmigrationPlan as API } from '@src/api/types';
import { ImmigrationPlan as Data } from '@src/types';

import generateTranslations from './translations';

const Factory = (api: API): Data => ({
  id: api.id,
  amount: api.amount,
  mostFamous: api.mostFamous,
  days: api.days,
  tripAdvises: api.tripAdvises,
  title: generateTranslations(api.title),
  amountText: generateTranslations(api.amountText),
  previousAmountText: generateTranslations(api.previousAmountText),
});

export default Factory;
